export const DEGREE_ENUM_MAP = {
  UNSPECIFIED: 'Unspecified',
  GED: 'GED',
  HIGH_SCHOOL: 'High School',
  SOME_COLLEGE: 'Some College',
  ASSOCIATES: 'Associates',
  BACHELORS: 'Bachelors',
  MASTERS: 'Masters',
  DOCTORATE: 'Doctorate',
}

export type Degree = keyof typeof DEGREE_ENUM_MAP;
export default DEGREE_ENUM_MAP
